// External
import _ from "lodash";
import { connect } from "react-redux";
import React, { useCallback, useState } from "react";

// Internal
import { IconButton } from "@toddle-edu/ds-web";
import { OpenBookStarOutlined } from "@toddle-edu/ds-icons";

// Relative
import classes from "./AIPanelContextBar.scss";
import {
  AIPanelInputBox,
  AIPanelSendButton,
  AIPanelVoiceToText,
  AIPanelLanguageSwitch,
  AIPanelContextBarAttachment,
  AIPanelContextSwitch,
  AIPanelContextSelection,
} from "./components";

/**
 * @description
 * AIPanelContextBar Component - Context bar for AI Panel with various controls
 * Matches the structure and layout of AIContextBar.js with internal state management
 * Connected to Redux for attachment and transcription functionality
 */
const AIPanelContextBar = props => {
  const {
    testId,
    sendEvent,
    entityType,
    isDisabled,
    inputMessage,
    contextFields,
    contextOptions,
    conversationId,
    setInputMessage,
    showContextList,
    conversationMetaData,
    renderMoreContextFields,
  } = props;

  const [isTranscribing, setIsTranscribing] = useState(false);
  const [voiceModalLang, setAiVoiceModalLang] = useState("en");

  const handleAttachmentUpload = () => {};

  const handleTranscriptionReceived = useCallback(
    transcript => setInputMessage({ value: transcript }),
    [setInputMessage]
  );

  return (
    <footer>
      {/* CONTEXT BAR */}
      <div className={classes.contextBarContainer}>
        <div className={classes.contextBar}>
          <AIPanelContextSwitch
            testId={testId}
            sendEvent={sendEvent}
            contextOptions={contextOptions}
            currentContext={conversationId}
            showContextList={showContextList}
            contextCount={_.compact(_.map(contextFields, "value")).length}
          />

          <AIPanelContextSelection
            testId={testId}
            sendEvent={sendEvent}
            contextFields={contextFields}
            showContextList={showContextList}
            renderMoreContextFields={renderMoreContextFields}
          />
        </div>
      </div>

      {/* MESSAGE INPUT FIELD */}
      <AIPanelInputBox
        isDisabled={isDisabled}
        inputMessage={inputMessage}
        setInputMessage={setInputMessage}
      />

      {/* BOTTOM ACTION BAR */}
      <div className={classes.actionsBar}>
        <div className={classes.actionBarItems}>
          <AIPanelContextBarAttachment
            isDisabled={isDisabled}
            testId={`${testId}-add-attachment`}
            conversationId={conversationId}
            onUpload={handleAttachmentUpload}
          />
          <AIPanelLanguageSwitch
            disabled={isDisabled}
            entityType={entityType}
            conversationId={conversationId}
            onChangeLanguage={setAiVoiceModalLang}
            conversationMetadata={conversationMetaData}
          />
          <IconButton
            type="plain"
            size="medium"
            dsVersion="2.0"
            variant="neutral"
            icon={<OpenBookStarOutlined />}
          />
        </div>
        <div className={classes.actionBarItems}>
          <div>
            <AIPanelVoiceToText
              testId={testId}
              entityType={entityType}
              isDisabled={isDisabled}
              conversationId={conversationId}
              isTranscribing={isTranscribing}
              setIsTranscribing={setIsTranscribing}
              onTranscriptionReceived={handleTranscriptionReceived}
            />
          </div>
          <AIPanelSendButton
            showStop={false}
            isSending={false}
            onStop={() => {}}
            isDisabled={isDisabled}
            onSend={() => sendEvent("SEND_MESSAGE")}
          />
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { conversationId } = ownProps;
  return { conversationId };
};

export default connect(mapStateToProps, null)(AIPanelContextBar);
